module.exports = __webpack_public_path__ + "img/AudiA7.7fbbcf54.png";